import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQAccordion() {
  const faqs = [{
    q: '¿Qué es exactamente el Sistema de Reprogramación Interna?',
    a: 'Es un protocolo digital de 30 días diseñado para regular tu sistema nervioso desde la raíz, utilizando técnicas de neurociencia aplicada y regulación somática.'
  }, {
    q: '¿En cuánto tiempo veré resultados?',
    a: 'Muchas mujeres reportan mejoras en su sueño y niveles de ansiedad desde la primera semana. El protocolo completo dura 30 días para crear cambios sostenibles.'
  }, {
    q: '¿Necesito experiencia previa en meditación o bienestar?',
    a: 'No. De hecho, está diseñado para mujeres a las que la meditación tradicional les genera más ansiedad. Las prácticas son corporales y muy fáciles de seguir.'
  }, {
    q: '¿Funciona si tengo muy poco tiempo al día?',
    a: 'Sí. Solo necesitas entre 5 y 15 minutos diarios. Las herramientas de emergencia toman menos de 2 minutos.'
  }, {
    q: '¿Cómo accedo al producto después de comprar?',
    a: 'Inmediatamente después de tu compra, recibirás un correo electrónico con acceso instantáneo para descargar todo el material.'
  }, {
    q: '¿Funciona en mi país? ¿Puedo pagar con mi tarjeta?',
    a: 'Sí, la plataforma de pago acepta tarjetas de crédito/débito de cualquier país y realiza la conversión a tu moneda local automáticamente.'
  }, {
    q: '¿Qué pasa si no me funciona? ¿Hay garantía?',
    a: 'Tienes una garantía incondicional de 30 días. Si aplicas el sistema y sientes que no es para ti, te devolvemos el 100% de tu dinero sin hacer preguntas.'
  }, {
    q: '¿Es esto solo otro ebook de autoayuda?',
    a: "No. Es un protocolo práctico basado en fisiología y neurociencia. No te pedimos que 'pienses positivo', te enseñamos a cambiar la respuesta biológica de tu cuerpo."
  }, {
    q: '¿Puedo hacerlo aunque esté tomando medicación?',
    a: 'Sí, es un complemento perfecto. Sin embargo, nunca debes alterar tu medicación sin consultar a tu médico tratante.'
  }, {
    q: '¿Por qué el precio es tan bajo si el valor es $67?',
    a: 'Queremos que esta información vital sea accesible para la mayor cantidad de mujeres posible. Es una oferta especial de lanzamiento por tiempo limitado.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 px-4 bg-beige-dark/10" data-id="element-136">
      <div className="max-w-3xl mx-auto" data-id="element-137">
        <div className="text-center mb-12" data-id="element-138">
          <h2 className="font-display font-bold text-3xl md:text-4xl text-teal mb-4" data-id="element-139">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-140">
          {faqs.map((faq, i) => <div key={i} className="border border-sage/30 rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-141">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-142">
                <span className="font-heading font-bold text-teal pr-4" data-id="element-143">
                  {faq.q}
                </span>
                <ChevronDown className={`text-sage-dark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-144" />
              </button>
              <AnimatePresence data-id="element-145">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-146">
                    <div className="px-6 pb-5 pt-1 text-neutral-gray font-sans text-sm leading-relaxed border-t border-sage/10" data-id="element-147">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}